import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import AddMemoryModal from "@/components/memories/AddMemoryModal";
import { NotificationButton } from "@/components/common/header/NotificationButton";
import { UserMenuButton } from "@/components/common/header/UserMenuButton";
import { SidebarTrigger } from "@/components/ui/sidebar";

const AppHeader = () => {
  const [showAddMemoryModal, setShowAddMemoryModal] = useState(false);
  const location = useLocation();

  // Get page title based on current route
  const getPageTitle = () => {
    const path = location.pathname;
    if (path === "/dashboard") return "Dashboard";
    if (path === "/people") return "People";
    if (path === "/memories") return "Memories";
    if (path === "/suggestions" || path.startsWith("/suggestions/")) return "Suggestions";
    if (path === "/profile") return "Profile";
    return "Dashboard";
  };

  return (
    <header className="sticky top-0 z-50 bg-white h-24">
      <div className="container mx-auto px-4 md:px-8 h-full">
        <div className="flex items-center justify-between h-full">
          {/* Mobile Sidebar Trigger */}
          <div className="md:hidden">
            <SidebarTrigger />
          </div>

          {/* Page Title */}
          <h1 className="text-xl font-medium font-euclid tracking-normal text-black">{getPageTitle()}</h1>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-6">
            {location.pathname === "/memories" && (
              <Button
                onClick={() => setShowAddMemoryModal(true)}
                className="bg-wabisabi-plum hover:bg-wabisabi-plum-dark text-white h-9 px-4"
              >
                <Plus className="w-4 h-4 mr-2" />
                Add Memory
              </Button>
            )}

            <NotificationButton />
            <UserMenuButton />
          </nav>

          {/* Mobile actions */}
          <div className="md:hidden flex items-center gap-2">
            <NotificationButton />
            <UserMenuButton />
          </div>
        </div>
      </div>

      {/* Add Memory Modal */}
      <AddMemoryModal
        isOpen={showAddMemoryModal}
        onClose={() => setShowAddMemoryModal(false)}
      />
    </header>
  );
};

export default AppHeader;